import Header from './components/Header';
import Hero from './components/Hero';
import {
  FaqSection,
  FeaturesSection,
  AppSection,
  ContactSection,
  AboutSection,
} from './components/InfoSections';
import { MediaSection, UpdatesSection, IndexSection } from './components/MediaSections';
import {
  TopicsSection,
  CarouselSection,
  RankingSection,
  CommentsSection,
  CardsSection,
} from './components/ContentSections';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        {/* 1. #faq - 常见问题 */}
        <FaqSection />

        {/* 2. #features - 平台优势 */}
        <FeaturesSection />

        {/* 3. #app - 移动观影 */}
        <AppSection />

        {/* 4. #contact - 联系我们 */}
        <ContactSection />

        {/* 5. #about - 关于555电影网 */}
        <AboutSection />

        {/* 6. #media - 精彩花絮 */}
        <MediaSection />

        {/* 7. #updates - 最新动态 */}
        <UpdatesSection />

        {/* 8. #index - 影视导航 */}
        <IndexSection />

        {/* 9. #topics - 热门标签 */}
        <TopicsSection />

        {/* 10. #carousel - 热门专题 */}
        <CarouselSection />

        {/* 11. #ranking - 热门排行 */}
        <RankingSection />

        {/* 12. #comments - 观众热评 */}
        <CommentsSection />

        {/* 13. #cards - 精选推荐 */}
        <CardsSection />
      </main>

      <Footer />
    </div>
  );
}